import util from '../util/util';
export default {
    // 轮播图数据
    section1: {
        // 图片地址
        link: util.get_img('case_banner.png'),
        // 标题
        title: '品质案例 效果非凡',
        // 描述
        description: '十余年专注数字营销，超过1000家优质品牌长期合作，深耕垂直行业，致力与每一个客户共创非凡的营销效果',
        cta: '我要投放'
    },
    // 案例卡片图块数据
    section2: {
        // 模块名称
        name: '平台优势',
        // 全部投放行业
        industry: [
            {
                key: '',
                val_key: '',
                val: '全部'
            },
            {
                key: 'education',
                val_key: '教育',
                val: '教育'
            },
            {
                key: 'ecommerce',
                val_key: '电商',
                val: '电商'
            },
            {
                key: 'finance',
                val_key: '金融保险',
                val: '金融保险'
            },
            {
                key: 'OTA',
                val_key: 'OTA',
                val: 'OTA'
            },
            {
                key: 'O2O',
                val_key: 'O2O',
                val: 'O2O'
            },
            {
                key: 'game',
                val_key: '游戏',
                val: '游戏'
            },
            {
                key: 'entertainment',
                val_key: '文娱体育',
                val: '文娱体育'
            },
            {
                key: 'other',
                val_key: '其他',
                val: '其他'
            }
        ],
        // 全部投放目的
        purpose: [
            {
                key: 'brand',
                val: '品牌营销'
            },
            {
                key: 'effect',
                val: '效果营销'
            }
        ]
        // 卡片数据
        // data: [
        //     {
        //         // 图片地址
        //         link: util.get_img('pic_case_audi.jpg'),
        //         // 广告主名称
        //         name: '英孚教育',
        //         // 广告主名称(en)
        //         name_en: 'yf',
        //         // 标题
        //         title: '英孚教育·英孚明星课堂携手有道词…',
        //         // 描述
        //         description: '汽车行业 | 原创视频 | 大数据 | 精准投放',
        //         // 标签(s)
        //         tags: [
        //             {
        //                 num: '1000万',
        //                 tag: '单日展示量'
        //             },
        //             {
        //                 num: '10%',
        //                 tag: '阅读转化率'
        //             },
        //             {
        //                 num: '50%',
        //                 tag: 'UV高于同行'
        //             }
        //         ],
        //         // 特征(s)
        //         features: [
        //             {
        //                 title: '投放背景',
        //                 description: '杭州补天网络有限公司成立于2014年4月'
        //             },
        //             {
        //                 title: '投放背景',
        //                 description: '杭州补天网络有限公司成立于2014年4月'
        //             },
        //             {
        //                 title: '投放背景',
        //                 description: '杭州补天网络有限公司成立于2014年4月'
        //             },
        //             {
        //                 title: '投放背景',
        //                 description: '杭州补天网络有限公司成立于2014年4月'
        //             }
        //         ]
        //     },
        //     {
        //         // 图片地址
        //         link: util.get_img('pic_case_suning.jpg'),
        //         // 详情图片
        //         detail_link: util.get_img('banner_CaseDetail_Yingfu_1280.jpg'), 
        //         // 广告主名称
        //         name: '苏宁易购',
        //         // 广告主名称(en)
        //         name_en: 'suning',
        //         // 标题
        //         title: '苏宁易购818电商大促单日千万曝光…',
        //         // 描述
        //         description: '汽车行业 | 原创视频 | 大数据 | 精准投放',
        //         // 标签(s)
        //         tags: [
        //             {
        //                 num: '1000万',
        //                 tag: '单日展示量'
        //             },
        //             {
        //                 num: '20%',
        //                 tag: '点击率提升'
        //             },
        //             {
        //                 num: '38%',
        //                 tag: '转化率提升'
        //             }
        //         ],
        //         // 特征(s)
        //         features: [
        //             {
        //                 title: '投放背景',
        //                 description: '杭州补天网络有限公司成立于2014年4月'
        //             },
        //             {
        //                 title: '投放背景',
        //                 description: '杭州补天网络有限公司成立于2014年4月'
        //             },
        //             {
        //                 title: '投放背景',
        //                 description: '杭州补天网络有限公司成立于2014年4月'
        //             },
        //             {
        //                 title: '投放背景',
        //                 description: '杭州补天网络有限公司成立于2014年4月'
        //             }
        //         ]
        //     },
        //     {
        //         // 图片地址
        //         link: util.get_img('pic_case_audi.jpg'),
        //         // 广告主名称
        //         name: '宝宝树',
        //         // 广告主名称(en)
        //         name_en: 'baobao',
        //         // 标题
        //         title: '奥迪·全新产品上市营销阅读量破百',
        //         // 描述
        //         description: '汽车行业 | 原创视频 | 大数据 | 精准投放',
        //         // 标签(s)
        //         tags: [
        //             {
        //                 num: '1000万',
        //                 tag: '单日展示量'
        //             },
        //             {
        //                 num: '10%',
        //                 tag: '阅读转化率'
        //             },
        //             {
        //                 num: '50%',
        //                 tag: 'UV高于同行'
        //             }
        //         ],
        //         // 特征(s)
        //         features: [
        //             {
        //                 title: '投放背景',
        //                 description: '杭州补天网络有限公司成立于2014年4月'
        //             },
        //             {
        //                 title: '投放背景',
        //                 description: '杭州补天网络有限公司成立于2014年4月'
        //             },
        //             {
        //                 title: '投放背景',
        //                 description: '杭州补天网络有限公司成立于2014年4月'
        //             },
        //             {
        //                 title: '投放背景',
        //                 description: '杭州补天网络有限公司成立于2014年4月'
        //             }
        //         ]
        //     },
        //     {
        //         // 图片地址
        //         link: util.get_img('pic_case_audi.jpg'),
        //         // 广告主名称
        //         name: '宝宝树',
        //         // 广告主名称(en)
        //         name_en: 'baobao',
        //         // 标题
        //         title: '奥迪·全新产品上市营销阅读量破百',
        //         // 描述
        //         description: '汽车行业 | 原创视频 | 大数据 | 精准投放',
        //         // 标签(s)
        //         tags: [
        //             {
        //                 num: '1000万',
        //                 tag: '单日展示量'
        //             },
        //             {
        //                 num: '10%',
        //                 tag: '阅读转化率'
        //             },
        //             {
        //                 num: '50%',
        //                 tag: 'UV高于同行'
        //             }
        //         ],
        //         // 特征(s)
        //         features: [
        //             {
        //                 title: '投放背景',
        //                 description: '杭州补天网络有限公司成立于2014年4月'
        //             },
        //             {
        //                 title: '投放背景',
        //                 description: '杭州补天网络有限公司成立于2014年4月'
        //             },
        //             {
        //                 title: '投放背景',
        //                 description: '杭州补天网络有限公司成立于2014年4月'
        //             },
        //             {
        //                 title: '投放背景',
        //                 description: '杭州补天网络有限公司成立于2014年4月'
        //             }
        //         ]
        //     },
        //     {
        //         // 图片地址
        //         link: util.get_img('pic_case_audi.jpg'),
        //         // 广告主名称
        //         name: '宝宝树',
        //         // 广告主名称(en)
        //         name_en: 'baobao',
        //         // 标题
        //         title: '奥迪·全新产品上市营销阅读量破百',
        //         // 描述
        //         description: '汽车行业 | 原创视频 | 大数据 | 精准投放',
        //         // 标签(s)
        //         tags: [
        //             {
        //                 num: '1000万',
        //                 tag: '单日展示量'
        //             },
        //             {
        //                 num: '10%',
        //                 tag: '阅读转化率'
        //             },
        //             {
        //                 num: '50%',
        //                 tag: 'UV高于同行'
        //             }
        //         ],
        //         // 特征(s)
        //         features: [
        //             {
        //                 title: '投放背景',
        //                 description: '杭州补天网络有限公司成立于2014年4月'
        //             },
        //             {
        //                 title: '投放背景',
        //                 description: '杭州补天网络有限公司成立于2014年4月'
        //             },
        //             {
        //                 title: '投放背景',
        //                 description: '杭州补天网络有限公司成立于2014年4月'
        //             },
        //             {
        //                 title: '投放背景',
        //                 description: '杭州补天网络有限公司成立于2014年4月'
        //             }
        //         ]
        //     },
        //     {
        //         // 图片地址
        //         link: util.get_img('pic_case_audi.jpg'),
        //         // 广告主名称
        //         name: '宝宝树',
        //         // 广告主名称(en)
        //         name_en: 'baobao',
        //         // 标题
        //         title: '奥迪·全新产品上市营销阅读量破百',
        //         // 描述
        //         description: '汽车行业 | 原创视频 | 大数据 | 精准投放',
        //         // 标签(s)
        //         tags: [
        //             {
        //                 num: '1000万',
        //                 tag: '单日展示量'
        //             },
        //             {
        //                 num: '10%',
        //                 tag: '阅读转化率'
        //             },
        //             {
        //                 num: '50%',
        //                 tag: 'UV高于同行'
        //             }
        //         ],
        //         // 特征(s)
        //         features: [
        //             {
        //                 title: '投放背景',
        //                 description: '杭州补天网络有限公司成立于2014年4月'
        //             },
        //             {
        //                 title: '投放背景',
        //                 description: '杭州补天网络有限公司成立于2014年4月'
        //             },
        //             {
        //                 title: '投放背景',
        //                 description: '杭州补天网络有限公司成立于2014年4月'
        //             },
        //             {
        //                 title: '投放背景',
        //                 description: '杭州补天网络有限公司成立于2014年4月'
        //             }
        //         ]
        //     },
        // ]
    }
}


// WEBPACK FOOTER //
// ./src/data/case.js